import {
  createAsyncThunk,
  createSlice,
  isFulfilled,
  isPending,
  isRejected,
  PayloadAction,
} from '@reduxjs/toolkit'
import { getConstants } from '@/api/utils'

export interface ConstantsState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: ConstantsState = {
  data: null,
  status: 'idle',
  error: null,
}

export const fetchConstants = createAsyncThunk(
  'constants/fetchConstants',
  async (_, { rejectWithValue }) => {
    try {
      return await getConstants()
    } catch (err: any) {
      return rejectWithValue(err?.message || 'Failed to fetch constants')
    }
  }
)

const constantsSlice = createSlice({
  name: 'constants',
  initialState,
  reducers: {
    setConstants(state, action: PayloadAction<any>) {
      state.data = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(isPending(fetchConstants), (state) => {
        state.status = 'loading'
      })
      .addMatcher(isFulfilled(fetchConstants), (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
      })
      .addMatcher(isRejected(fetchConstants), (state, action) => {
        state.status = 'failed'
        state.error = action.payload as string
      })
  },
})

export const { setConstants } = constantsSlice.actions
export default constantsSlice.reducer
